import { connect } from 'react-redux';

import { send as onSendAlert } from 'ha/modules/Alertbar/actions';
import { changeLocation as onChangeLocation } from 'ha/modules/URLLocationHandler';
import requestGoogleLogin from '../actions/requestGoogleLogin';

import Root from '../components/Root';

const mapDispatchToProps = {
  requestGoogleLogin,
  onSendAlert,
  onChangeLocation,
};

export default connect(
  null,
  mapDispatchToProps,
)(Root);
